<template>
    <VJoyAvatar
        size="small"
        :full-name="umbrellaIdentity?.fullName"
        :photo-url="umbrellaPhoto"
        :color="umbrellaPhoto ? 'transparent' : 'secondary'"
        class="navbar-umbrella-avatar"
        :class="{'navbar-umbrella-avatar--text': !umbrellaPhoto}"
    />
</template>
<script setup lang="ts">
    import {computed} from 'vue';
    import {storeToRefs} from 'pinia';
    import {VJoyAvatar} from '@maltjoy/core-vue';
    import {useUserStore} from '../../user';

    const {avatarSize = '18px'} = defineProps<{
        avatarSize?: string;
    }>();

    const userStore = useUserStore();
    const {userIdentities} = storeToRefs(userStore);

    const umbrellaIdentity = userIdentities.value.find((identity) => {
        return identity.type === 'UMBRELLA';
    });
    const umbrellaPhoto = computed(() => {
        return umbrellaIdentity?.photo ? `${umbrellaIdentity.photo?.baseUrl}/${umbrellaIdentity.photo?.name}?func=crop&w=30&h=30` : undefined;
    });
</script>
<style lang="scss">
    .navbar-umbrella-avatar {
        --avatar-size: v-bind(avatarSize) !important;
        width: v-bind(avatarSize);
        height: v-bind(avatarSize);
        font-size: var(--joy-font-size-primary-800);
        flex: 0 0 auto;

        &--text {
            font-size: unset;
        }
    }
</style>
